const LIMIT = 10
const CART_ATTRIBUTE_KEY = 'recently_viewed_products'
const SESSION_STORAGE_KEY = 'recentlyViewedProducts'

class RecentlyViewedStore {
  #items = window.localStorage.getItem(SESSION_STORAGE_KEY)
    ? JSON.parse(window.localStorage.getItem(SESSION_STORAGE_KEY))
    : []

  track () {
    if (window.ShopifyAnalytics.meta.page.pageType !== 'product') {
      return this.sync()
    }

    const handle = window.location.pathname.split('/').pop()
    if (!handle) return

    this.set(handle)
  }

  async set (handle) {
    const newItems = (this.#items.includes(handle)
      ? [handle].concat(this.#items.filter(h => h !== handle))
      : [handle].concat(this.#items)
    ).slice(0, LIMIT)
    window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newItems))

    // No sections - this fires unconditionally on every product page view,
    // nothing on screen needs to reflect it, so there's no reason to pay
    // for a full push-cart render (including GWP's tier ladder in
    // push-cart-items) on every single page load.
    await window.BAO.Cart.updateCartAttributes({
      [CART_ATTRIBUTE_KEY]: newItems.join(','),
    }, { sections: [] })

    return newItems
  }

  async sync () {
    await window.BAO.Cart.updateCartAttributes({
      [CART_ATTRIBUTE_KEY]: this.#items.join(','),
    }, { sections: [] })
  }

  get items () {
    return this.#items.slice(0, LIMIT)
  }
}

const store = Object.freeze(new RecentlyViewedStore())
store.track()

window.BAO.RecentlyViewed = {
  store,
}
